import { render, staticRenderFns } from "./LmNumberInputV2.vue?vue&type=template&id=747a465b"
import script from "./LmNumberInputV2.vue?vue&type=script&lang=js"
export * from "./LmNumberInputV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports